// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  guestId: __t.u64(),
  x: __t.f32(),
  z: __t.f32(),
  floor: __t.u32(),
  targetX: __t.f32(),
  targetZ: __t.f32(),
  targetFloor: __t.u32(),
  state: __t.string(),
};
